<div id="rightSideBar" [hidden]="!selectedItems || selectedItems.length == 0">
    <div class="rightSidePanel d-flex flex-column w-70pc active">
        <header class="panel-header">
            <div class="viewDemo title-and-video">
                <h2>{{ panelHeading }}</h2>
            </div>            
            <div class="panel-left-btn">
                <button type="button" class="btn eod-btn-outline-warning mr-2" *ngIf="gridData.length === 1" (click)="fnShowConfigureshowLoggingAlertPanel()">
                    {{ 'label_log' | translate: param }}
                </button>
                <button type="button" class="btn eod-btn-primary mr-2"(click)="saveAssignments()" [ngClass]="{'disabled': disableSave }"> 
                    {{ 'save_text' | translate }}
                </button>
                <button type="button" class="btn eod-btn-outline-warning" (click)="fnClosePanel()">
                    {{ 'label_close' | translate }}
                </button>
            </div>
        </header>
        <div class="eod-panel-body">
            <div class="block mt-2">
                <div class="row padding-top-10">
                    <div class="col-md-3 pl-0 pr-2">
                        <div class="input-group">
                            <ng-select id="approverName" class="solo-dropdown filterDropdown" [items]="approversList"
                                bindLabel="displayName" bindValue="employeeID" placeholder="Approver Name"
                                [clearable]="false" [selectOnTab]="true" required-field [(ngModel)]="assignedApproverId"
                                (change)="onApproverChange()" notFoundText="{{ 'no_data_available' | translate }}">
                            </ng-select>
                        </div>
                        <small class="d-block mt-1"  *ngIf="assignedApproverId">
                            <span><strong>{{ 'label_email' | translate }}:</strong> {{selectedApproverEmail}}
                            </span>
                            <span class="d-block"><strong>{{ 'label_cost_centre' | translate }}:</strong>
                                {{formateCostCentreName()}} </span>
                        </small>
                        <span class="alert-danger" *ngIf="selectedApproverStatus"> <strong>{{ 'label_approver_status' | translate }}:&nbsp;</strong>
                            {{ selectedApproverStatus }}
                        </span>
                    </div>
                    <!-- <div class="col-md-3 px-2">
                        <div *ngIf="itemType == 3" class="input-group">
                            <ng-select class="solo-dropdown filterDropdown" [items]="costCentreList"
                                bindLabel="costCentreName" bindValue="costCentreId" placeholder="Cost Centre Name"
                                [clearable]="false" [selectOnTab]="true" required-field
                                [(ngModel)]="assignedCostCentreId" (change)="onCostCentreChange()"
                                notFoundText="{{ 'no_data_available' | translate }}">
                            </ng-select>
                            </div>
                            
                    </div> -->
                    <div class="col-md-3 px-2 input-group" *ngIf="itemType == 3">
                        <ng-select id="delegateName"  class="solo-dropdown filterDropdown" [items]="delegateList"
                            bindLabel="employeeName" bindValue="employeeId" placeholder="Delegate Name"
                            [clearable]="false" [selectOnTab]="true" required-field [(ngModel)]="assignedDelegateId"
                            (change)="onDelegateChange()" notFoundText="{{ 'no_data_available' | translate }}">
                        </ng-select>
                    </div>
                    <div class="col-md-1 px-2">
                        <button class="btn btn-primary f-13 mt-1"
                            [ngClass]="{'disabled bg-secondary opacity-60': disableAssign}"
                            (click)="assignApprovers()">
                            {{ "label_assign" | translate }}
                        </button>
                    </div>
                </div>
                <p class="fw-600 text-logo-blue lH-30">{{ anyTextForDisplay }} </p>
            </div>
            <div class="block mt-2 heightCalc-13">
                <div class="row">
                    <div class="col-md-12 col-sm-12 col-lg-12 col-xl-12 no-padding-right-left heightCalc-17">
                        <h6 class="text-charcoal-black fw-700 f-14">
                            {{ selectedItemsText }}:
                        </h6>

                        <!----------------------Start Grid--------------------------->
                        <app-grid [columns]="gridColumnDefs" [data]="gridData" [gridConfigItems]="gridConfigItems"
                            (onCellClick)="fnOnGridCellClick($event)">
                        </app-grid>
                        <!----------------------End Grid--------------------------->
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!----------------------Side Panels--------------------------->
<employee-status-panel [hidden]="!showApproverStatusPanel" (closePanel)="closeEmployeeStatusPanel($event)"
    (onRemoveApprover)="onRemoveApprover($event)" [employeesList]="employeesList" [costCentre]="approverListCostCentre"
    [costCentreCode]="approverListCostCentreCode" [costCentreId]="approverListCostCentreId" [itemType]="panelItemType">
</employee-status-panel>